import { Action } from 'redux'
import { notification } from 'antd'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { ICreateMatchListGroupPayload } from '@app-store/slices/matchListGroups/create'

interface TaskAction extends Action {
    payload: ICreateMatchListGroupPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.matchListGroups.create

function* createMatchListGroupSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.post(`/companies/match-list-groups`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Match list group created successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* createMatchListGroupSaga(): any {
    yield takeLatest<TaskAction>(onRequest, createMatchListGroupSagaTask)
}

export default createMatchListGroupSaga
